(function() {

  function moveWishlistButton() {
    document.querySelectorAll('.cqa-image-wrapper').forEach(function(wrapper) {
      var wishlistBtn = wrapper.querySelector('.cqa-overlay .cqa-wishlist-btn');
      if (wishlistBtn) {
        wrapper.appendChild(wishlistBtn);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', moveWishlistButton);
  new MutationObserver(moveWishlistButton)
    .observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', function(event) {
    if (event.target.closest('.cqa-wishlist-btn')) {
      event.preventDefault();
      var card = event.target.closest('product-card, li[data-product-id]');
      var swBtn = card && card.querySelector('.st-wishlist-button--product-card, .st-wishlist-button[data-type="product-card"]');
      if (swBtn) swBtn.click();
    }
    if (event.target.closest('.cqa-qv-btn')) {
      event.stopPropagation();
    }
    var atcBtn = event.target.closest('.cqa-atc-btn');
    if (atcBtn) {
      event.preventDefault();
      event.stopPropagation();
      if (atcBtn.disabled) return;
      var card = atcBtn.closest('product-card');
      if (!card) return;
      var addBtn = card.querySelector('.quick-add__button--add[type="submit"]');
      if (addBtn && !addBtn.disabled) {
        addBtn.click();
        atcBtn.textContent = '✓';
        atcBtn.disabled = true;
        setTimeout(function() {
          atcBtn.disabled = false;
          atcBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>';
        }, 1500);
        return;
      }
      var chooseBtn = card.querySelector('.quick-add__button--choose');
      if (chooseBtn) { chooseBtn.click(); return; }
      var link = card.querySelector('.product-card__link');
      if (link) window.location.href = link.href;
    }
  });


    /* =========================================
     AUTO SUBCATEGORY SEARCH
     Search: "Maheswari Silk"
     → Subcategory: "Maheswari Silk"
     ========================================= */

  (function () {
    var STORAGE_KEY = 'auto_subcategory_search';

    function normalize(text) {
      return (text || '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    }

    function saveSearchQuery(query) {
      query = normalize(query);

      if (query) {
        sessionStorage.setItem(STORAGE_KEY, query);
      }
    }

    function getSavedSearchQuery() {
      return normalize(sessionStorage.getItem(STORAGE_KEY));
    }

    function clearSavedSearchQuery() {
      sessionStorage.removeItem(STORAGE_KEY);
    }

    /*
     * Capture the normal Dawn search submission.
     */
    document.addEventListener('submit', function (event) {
      var form = event.target;

      if (!form || !form.matches('form[action*="/search"]')) {
        return;
      }

      var input = form.querySelector(
        'input[name="q"], input[type="search"]'
      );

      if (input && input.value) {
        saveSearchQuery(input.value);
      }
    }, true);


    /*
     * Also capture Enter/search-button navigation.
     */
    document.addEventListener('click', function (event) {
      var button = event.target.closest(
        'button[type="submit"], input[type="submit"]'
      );

      if (!button) return;

      var form = button.closest('form[action*="/search"]');

      if (!form) return;

      var input = form.querySelector(
        'input[name="q"], input[type="search"]'
      );

      if (input && input.value) {
        saveSearchQuery(input.value);
      }
    }, true);


    /*
     * Find the Subcategory filter and automatically
     * select the matching value.
     */
    function applySubcategoryFilter() {
      var query = getSavedSearchQuery();

      if (!query) return;

      /*
       * Only run on search results pages.
       */
      if (!window.location.pathname.startsWith('/search')) {
        return;
      }

      /*
       * Don't run again if a filter has already been applied.
       */
      var currentUrl = new URL(window.location.href);

      if (
        currentUrl.searchParams.has('filter.p.m.custom.subcategory')
      ) {
        clearSavedSearchQuery();
        return;
      }

      /*
       * Find the Subcategory filter section.
       */
      var filterSections = document.querySelectorAll(
        'details, .facets__disclosure, .facets-wrap, .facets__wrapper'
      );

      var subcategorySection = null;

      filterSections.forEach(function (section) {
        if (subcategorySection) return;

        var text = normalize(section.textContent);

        if (
          text.includes('subcategory')
        ) {
          subcategorySection = section;
        }
      });

      if (!subcategorySection) {
        return;
      }

      /*
       * Find a filter checkbox whose label matches
       * the search query.
       */
      var checkboxes = subcategorySection.querySelectorAll(
        'input[type="checkbox"]'
      );

      var matchingCheckbox = null;

      checkboxes.forEach(function (checkbox) {
        if (matchingCheckbox) return;

        var label = null;

        if (checkbox.id) {
          label = document.querySelector(
            'label[for="' + CSS.escape(checkbox.id) + '"]'
          );
        }

        if (!label) {
          label = checkbox.closest('label');
        }

        if (!label) return;

        var labelText = normalize(label.textContent);

        if (labelText === query) {
          matchingCheckbox = checkbox;
        }
      });

      /*
       * If exact match isn't found, try a partial match.
       */
      if (!matchingCheckbox) {
        checkboxes.forEach(function (checkbox) {
          if (matchingCheckbox) return;

          var label = null;

          if (checkbox.id) {
            label = document.querySelector(
              'label[for="' + CSS.escape(checkbox.id) + '"]'
            );
          }

          if (!label) {
            label = checkbox.closest('label');
          }

          if (!label) return;

          var labelText = normalize(label.textContent);

          if (
            labelText.includes(query) ||
            query.includes(labelText)
          ) {
            matchingCheckbox = checkbox;
          }
        });
      }

      if (!matchingCheckbox) {
        return;
      }

      /*
       * Select the existing Shopify filter.
       */
      if (!matchingCheckbox.checked) {
        matchingCheckbox.click();

        clearSavedSearchQuery();
      }
    }


    /*
     * Search results can be rendered/re-rendered dynamically,
     * so check after page load and after Shopify updates the DOM.
     */
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        setTimeout(applySubcategoryFilter, 500);
        setTimeout(applySubcategoryFilter, 1200);
        setTimeout(applySubcategoryFilter, 2000);
      }
    );

    new MutationObserver(function () {
      applySubcategoryFilter();
    }).observe(document.body, {
      childList: true,
      subtree: true
    });

  })();

})();
